import { Controller } from "@hotwired/stimulus"
import { patch } from "@rails/request.js";

export default class extends Controller {
  static values = { url: String };

  connect() {
    this.originalCursor = document.body.style.cursor;
  }

  async toggleLayout(event) {
    const checkbox = event.currentTarget;
    const url = this.urlValue;

    try {
      this.startLoading(checkbox);
      await patch(url);
    } finally {
      this.stopLoading(checkbox);
    }
  }

  startLoading(checkbox) {
    document.body.style.cursor = "wait"; // Change cursor to spinner
    checkbox.disabled = true; // Disable the checkbox to prevent multiple clicks
  }

  stopLoading(checkbox) {
    document.body.style.cursor = this.originalCursor; // Restore cursor
    checkbox.disabled = false; // Re-enable checkbox after request completes
  }
}
